<template>
    <AuthenticatedShell full-bleed-brand>
        <div class="ea-config-layout">
            <div class="ea-config-scroll">
        <div class="wizard ea-config-wizard">
            <section class="section command-list primary config-section">
                <div class="config-panel">
                    <header class="config-header">
                        <h2>Configurações da conta</h2>
                        <p class="config-lead">
                            Dados pessoais e segurança (antes no painel lateral).
                        </p>
                    </header>

                    <div class="config-body">
                        <div class="config-avatar-row">
                            <div class="avatar-preview" aria-hidden="true">
                                <span class="avatar-preview-initials">{{ profileInitials }}</span>
                            </div>
                            <div class="avatar-upload">
                                <label class="config-label">Foto do perfil</label>
                                <input
                                    type="file"
                                    class="form-control file-input"
                                    accept="image/*"
                                    @change="onAvatarFile"
                                />
                            </div>
                        </div>

                        <div class="form-grid">
                            <div class="form-group">
                                <label class="config-label">Nome</label>
                                <input
                                    v-model="userData.name"
                                    type="text"
                                    class="form-control config-input"
                                />
                            </div>
                            <div class="form-group">
                                <label class="config-label">E-mail</label>
                                <input
                                    v-model="userData.email"
                                    type="email"
                                    class="form-control config-input"
                                    readonly
                                />
                            </div>
                        </div>

                        <div class="config-actions">
                            <button
                                type="button"
                                class="btn btn-form secondary"
                                @click="logout"
                            >
                                Sair da conta
                            </button>
                            <button
                                type="button"
                                class="btn btn-form primary"
                                @click="saveProfile"
                            >
                                Salvar alterações
                            </button>
                        </div>

                        <div class="config-divider" />

                        <h3 class="config-subtitle">Redefinir senha</h3>
                        <p class="config-hint">
                            Preencha apenas caso queira alterar sua senha.
                        </p>
                        <div class="form-grid">
                            <div class="form-group">
                                <label class="config-label">Nova senha</label>
                                <input
                                    v-model="passwordNew"
                                    type="password"
                                    class="form-control config-input"
                                    placeholder="Nova senha"
                                    autocomplete="new-password"
                                />
                            </div>
                            <div class="form-group">
                                <label class="config-label">Confirmar nova senha</label>
                                <input
                                    v-model="passwordConfirm"
                                    type="password"
                                    class="form-control config-input"
                                    placeholder="Repita a nova senha"
                                    autocomplete="new-password"
                                />
                            </div>
                        </div>
                        <div class="config-actions">
                            <button
                                type="button"
                                class="btn btn-form primary"
                                @click="savePassword"
                            >
                                Salvar senha
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
            </div>
        </div>
    </AuthenticatedShell>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';
import AuthenticatedShell from '@/components/layout/AuthenticatedShell.vue';
import users from '@/utils/users';
import { initialsFromFullName } from '@/utils/userDisplay';

export default {
    name: 'EscoConfiguracoes',
    components: { AuthenticatedShell },
    data() {
        return {
            userData: {
                name: '',
                email: ''
            },
            passwordNew: '',
            passwordConfirm: ''
        };
    },
    computed: {
        ...mapState(['token', 'user']),
        profileInitials() {
            return initialsFromFullName(this.userData.name);
        }
    },
    mounted() {
        this.loadUser();
    },
    methods: {
        ...mapActions(['storeToken', 'storeRefreshToken', 'storeUserInfoData']),
        notify(msg, type = 'info') {
            toast(msg, { autoClose: 3000, type });
        },
        async loadUser() {
            if (!this.token || !this.user?.user_id) return;
            try {
                const response = await users.getUsersById(this.token, this.user.user_id);
                this.userData.name = response.name || '';
                this.userData.email = response.email || '';
                this.storeUserInfoData({ userInfoData: response });
            } catch (e) {
                console.error(e);
                this.notify('Não foi possível carregar seus dados.', 'error');
            }
        },
        onAvatarFile(ev) {
            const file = ev.target.files && ev.target.files[0];
            if (!file) return;
            this.notify('Upload de avatar será integrado à API em breve.', 'info');
        },
        saveProfile() {
            this.notify('Alterações salvas localmente. Integração com API de perfil pendente.', 'success');
        },
        savePassword() {
            if (this.passwordNew !== this.passwordConfirm) {
                this.notify('As senhas não coincidem.', 'error');
                return;
            }
            if (this.passwordNew && this.passwordNew.length < 6) {
                this.notify('Use pelo menos 6 caracteres na nova senha.', 'error');
                return;
            }
            this.notify('Alteração de senha requer endpoint no backend.', 'info');
            this.passwordNew = '';
            this.passwordConfirm = '';
        },
        logout() {
            this.storeToken({ token: null });
            this.storeRefreshToken({ refreshToken: null });
            this.$router.push('/');
        }
    }
};
</script>

<style lang="scss" scoped>
$ea-accent: #8b9185;
$ea-accent-soft: rgba(139, 145, 133, 0.18);
$ea-card: #15161a;
$ea-elevated: #1c1d22;
$ea-muted: #8b9099;

.ea-config-layout {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ea-config-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 0.5rem clamp(0.75rem, 2.5vw, 1.5rem) 1.25rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.ea-config-scroll::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.ea-config-wizard {
    width: 100%;
    max-width: none;
}

.config-section {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 0;
}

.config-panel {
    background: $ea-card;
    border-radius: 12px;
    padding: clamp(1.25rem, 3vw, 2rem);
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: none;
}

.config-header h2 {
    margin: 0 0 0.35rem;
    font-size: clamp(1.25rem, 2.5vw, 1.6rem);
    color: #fff;
    font-weight: 700;
}

.config-lead {
    margin: 0 0 1.25rem;
    color: $ea-muted;
    font-size: 14px;
    line-height: 1.55;
}

.config-body {
    color: #fff;
}

.config-avatar-row {
    display: flex;
    gap: 1.25rem;
    align-items: flex-end;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
}

.avatar-preview {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    overflow: hidden;
    background: $ea-elevated;
    flex-shrink: 0;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.avatar-preview-initials {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #0f1012;
    background: linear-gradient(145deg, #e8eadf 0%, #c5c9bc 100%);
}

.avatar-upload {
    flex: 1;
    min-width: 200px;
}

.config-label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 13px;
    color: #c8cdd8;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
}

.config-input {
    background: $ea-elevated !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    color: #fff !important;
    border-radius: 10px !important;
}
.config-input:focus {
    outline: none;
    border-color: rgba(139, 145, 133, 0.55) !important;
    box-shadow: 0 0 0 2px $ea-accent-soft;
}

.file-input {
    font-size: 13px;
}

.config-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin: 1.25rem 0;
}

.btn-form {
    padding: 0.6rem 1.35rem;
    border-radius: 999px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.btn-form:active {
    transform: scale(0.98);
}

.btn-form.primary {
    background: #3d4046;
    color: #f0f1f3;
    box-shadow: none;
}
.btn-form.primary:hover {
    background: #484c54;
}

.btn-form.secondary {
    background: transparent;
    color: #c4c8cf;
    border: 1px solid rgba(255, 255, 255, 0.12);
}
.btn-form.secondary:hover {
    border-color: rgba(139, 145, 133, 0.4);
    color: #e8eaef;
}

.config-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.08);
    margin: 1.5rem 0;
}

.config-subtitle {
    margin: 0 0 0.35rem;
    font-size: 1.05rem;
    color: #fff;
    font-weight: 600;
}

.config-hint {
    margin: 0 0 1rem;
    color: $ea-muted;
    font-size: 13px;
}
</style>
